import React from 'react';
import KPIStatistic from '../components/Dashboard/KPIStatistic';
import StatisticsTable from '../components/Dashboard/StatisticsTable';

function SoloStatisticsRow({
  selectedAsset,
  selectedAccount,
  userProfile,
  statistics,
}) {
  return (
    <div
      data-testid="solo-statistics-row"
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:items-start"
    >
      <div className="min-w-0">
        <KPIStatistic
          broker={selectedAsset.broker}
          account={selectedAsset.broker === 'okx' ? userProfile?.name : selectedAccount.account}
          symbol={selectedAsset.symbol}
          sectype={selectedAsset.sectype}
        />
      </div>
      <div className="min-w-0">
        <StatisticsTable data={statistics} />
      </div>
    </div>
  );
}

export default SoloStatisticsRow;
